import { render, staticRenderFns } from "./RedirectPage.vue?vue&type=template&id=927b1616&scoped=true&lang=pug&"
import script from "./RedirectPage.vue?vue&type=script&lang=js&"
export * from "./RedirectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927b1616",
  null
  
)

export default component.exports